import { isNativeApp } from 'shared/javascripts/util/detection'
import { mobileBreakpoint } from 'shared/javascripts/util/mobile_breakpoint'

let pageLayout: HTMLElement | null

function minimizeNavigation(): void {
  const navigation = pageLayout?.querySelector('.navigation')
  if (navigation) {
    if (window.scrollY <= 20) {
      document
        .querySelector<HTMLElement>('.frontend-layout')!
        .classList.remove('-navigation-collapsed')
    } else {
      document
        .querySelector<HTMLElement>('.frontend-layout')!
        .classList.add('-navigation-collapsed')
    }
  }
}

up.compiler(
  '[data-frontend-layout]',
  (element: HTMLElement, { modifiers }: { modifiers: string }) => {
    if (up.layer.isOverlay()) {
      // When rendering inside a modal, we do not want to update the layout used in the background.
      // The modal is not part of `.frontend-layout` at all, so there is nothing to update either.
      return
    }

    const layout = element.closest<HTMLElement>('.frontend-layout')!
    pageLayout = layout.querySelector<HTMLElement>('.frontend-layout--navigation')

    const existingModifiers = Array.from(layout.classList).filter((className) =>
      className.match(/^-/),
    )

    layout.classList.remove(...existingModifiers)
    if (modifiers && modifiers.length > 0) {
      layout.classList.add(...modifiers.split(' '))
    }

    function checkSticky(): void {
      if (!modifiers.includes('sticky')) {
        layout.classList.toggle('-sticky', !isNativeApp())
      }
    }
    checkSticky()

    // Must run after the modifiers were applied: resetting the class list above also dropped
    // `-navigation-collapsed`, so the collapsed navigation needs to be re-evaluated.
    if (!isNativeApp() && !mobileBreakpoint.matches) {
      document.addEventListener('scroll', minimizeNavigation)
      minimizeNavigation()
    }

    return () => {
      document.removeEventListener('scroll', minimizeNavigation)
    }
  },
)
